/**
 * @author Jorge Casas
 * @creationDate 09/07/2024 
 */

import React from 'react';
import { translate } from 'react-i18next';

/**
 * @function AssetsFormCodesLabel
 * 
 * @description This function returns the QR and Barcode of an asset
 * 
 * @param {object} values - The values of the asset
 * @param {object} t - The translation function
 * @returns {React.Component} - The QR and Barcode of the asset
 * @throws {Error} - The error message
 */
const AssetsFormCodesLabel = ({ values, t }) => {
  const download = (e) => {
    e.preventDefault();
    const path = e.target.href.replace(/^https:\/\//i, 'http://');
    fetch(path, {
      method: 'GET',
      headers: {},
    })
      .then((response) => {
        response.arrayBuffer().then(function (buffer) {
          const url = window.URL.createObjectURL(new Blob([buffer]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'image.png');
          document.body.appendChild(link);
          link.click();
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div className="row my-3 align-items-center bbottom">
      <div className="col-sm-12">
        <h5>
          <b>{t('assets.section.codes')}</b>
        </h5>
        <br />
      </div>
      <div className="col-sm-6 text-center">
        <a href={values.qrUrl} target="__brank">
          <img src={values.qrUrl} style={{ width: '70%' }} />
        </a>
        <br></br>
        <a href={values.qrUrl} download onClick={(e) => download(e)}>
          <i className="fa fa-download" />
          {t('assets.section.downloadQR')}
        </a>
      </div>
      <div className="col-sm-6 text-center">
        <a href={values.barcodeUrl} target="__brank">
          <img src={values.barcodeUrl} style={{ width: '70%' }} />
        </a>
        <br></br>
        <a href={values.barcodeUrl} download onClick={(e) => download(e)}>
          <i className="fa fa-download" />
          {t('assets.section.downloadBarcode')}
        </a>
      </div>
    </div>
  );
};

export default translate()(AssetsFormCodesLabel);



// WEBPACK FOOTER //
// src/components/assets/form_sections/AssetFormCodesLabel.js